import { GetUserVacationCountResponse, UserVacationCountRpc } from "rpc/UserVacationCountRpc";
import { AData } from "./AData";

export class UserVacationStatisticsData extends AData<GetUserVacationCountResponse> {

    private static cache: GetUserVacationCountResponse = null;

    protected doLoad(): Promise<GetUserVacationCountResponse> {
        return UserVacationCountRpc.get();
    }

    protected getCached(): GetUserVacationCountResponse {
        return UserVacationStatisticsData.cache;
    }

    protected storeCached(data: GetUserVacationCountResponse) {
        UserVacationStatisticsData.cache = data;
    }

}